export default __webpack_public_path__ + "static/media/Submersible.d1d1ef56.jpg";